// extracted by mini-css-extract-plugin
export default {"BetaMessage":"BetaMessage_BetaMessage__ogQWV","title":"BetaMessage_title__SQQmh","text":"BetaMessage_text__TDflF"};